<template>
  <div class="container">
    <h3 class="title">Jakie urządzenie wymaga naprawy?</h3>
    <div class="btn-group">
      <button
        type="button"
        class="btn"
        :style="{ background: $color }"
        @click="btnHandler('agd')"
      >Sprzęt AGD</button>
      <button
        type="button"
        class="btn"
        :style="{ background: $color }"
        @click="btnHandler('rtv')"
      >Sprzęt RTV</button>
    </div>
    <div class="btn-group">
      <button
        type="button"
        class="btn full"
        :style="{ background: $color }"
        @click="btnHandler('elektronika')"
      >Sprzęt PC</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "StepHomeRepair",
  methods: {
    ...mapMutations(["setUserData", "setAssistanceStep"]),
    btnHandler(EquipmentType) {
      this.setUserData({ EquipmentType });
      this.setAssistanceStep("homeRepairVendor");
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepHomeRepair.vue